import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { RenderDatePicker } from "./RenderDatePicker";
import { RenderField } from "../../components/RenderField";
import { MCIcon } from "loft-taxi-mui-theme";
import { CCBlock } from "./CCBlock";

const cardNumber = e => {
  const { value } = e.target;
  if (!value) {
    e.target.value = "";
  }
  const match =
    value
      .replace(/\D/g, "")
      .substring(0, 16)
      .match(/.{1,4}/g) || [];
  e.target.value = match.join(" ");
};

const cvc = e => {
  const { value } = e.target;
  if (!value) {
    e.target.value = "";
  }
  e.target.value = value.replace(/\D/g, "").substring(0, 3);
};

const cardName = e => {
  const { value } = e.target;
  if (!value) {
    e.target.value = "";
  }
  e.target.value = value.toUpperCase();
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginBottom: 1
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing()
  }
});

export const PaymentFormView = withStyles(styles)(
  ({ classes, handleSubmit, register, errors }) => {
    return (
      <form onSubmit={handleSubmit}>
        <Grid container alignContent="center">
          <Grid item xs={12}>
            <Grid
              container
              className={classes.root}
              justify="center"
              spacing={4}
            >
              <Grid item xs={6}>
                <CCBlock>
                  <MCIcon />
                  <RenderField
                    required
                    error={!!errors.cardNumber}
                    helperText={
                      !!errors.cardNumber && errors.cardNumber.message
                    }
                    name="cardNumber"
                    label="Номер карты"
                    placeholder="0000 0000 0000 0000"
                    maxLength="12"
                    onChange={cardNumber}
                    fullWidth
                    inputRef={register}
                  />
                  <RenderDatePicker
                    clearable
                    name="date"
                    required
                    label="Срок действия"
                    inputRef={register}
                  />
                </CCBlock>
              </Grid>
              <Grid item xs={6}>
                <CCBlock>
                  <RenderField
                    required
                    error={!!errors.cardName}
                    helperText={
                      !!errors.cardName && errors.cardName.message
                    }
                    name="cardName"
                    label="Имя владельца"
                    placeholder="USER NAME"
                    onChange={cardName}
                    fullWidth
                    inputRef={register}
                  />
                  <RenderField
                    required
                    error={!!errors.cvc}
                    helperText={
                      !!errors.cvc && errors.cvc.message
                    }
                    name="cvc"
                    label="CVC"
                    onChange={cvc}
                    inputRef={register}
                  />
                </CCBlock>
              </Grid>
            </Grid>
            <Grid align="center">
              <Button
                variant="contained"
                color="primary"
                elevation={0}
                type="submit"
                className={classes.button}
              >
                Сохранить
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    );
  }
);

PaymentFormView.defaultProps = {
  errors: {}
};
